import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
import { defineComponent, reactive, openBlock, createElementBlock, normalizeClass, unref, createVNode, withCtx, createElementVNode, withModifiers, Fragment, renderList, toDisplayString, normalizeStyle, createTextVNode } from 'vue';
import { CaretRightOutlined } from '@ant-design/icons-vue';
import { useStyleConfig } from '../abstract';
import useThemeStore from './store';
import InputNumber from '../input-number/InputNumber.js';
import { Collapse, CollapsePanel, InputGroup, Input, Button } from 'ant-design-vue';
var _sfc_main = /*#__PURE__*/defineComponent({
  __name: 'StyleEditor',
  setup: function setup(__props) {
    var _useStyleConfig = useStyleConfig('style-editor'),
      prefixCls = _useStyleConfig.prefixCls;
    var _useThemeStore = useThemeStore(),
      theme = _useThemeStore.theme,
      setRadius = _useThemeStore.setRadius;
    var radius = theme.radius;
    function onRadiusChange(key, value) {
      setRadius(_defineProperty({}, key, value));
    }
    var radiusList = [{
      name: 'RadiusXS',
      key: 'radius-xs'
    }, {
      name: 'RadiusSM',
      key: 'radius-sm'
    }, {
      name: 'RadiusMD',
      key: 'radius-md'
    }, {
      name: 'RadiusLG',
      key: 'radius-lg'
    }];
    var shadowList = reactive([{
      name: '一级阴影',
      key: 'box-shadow-1',
      value: '0 1px 2px -2px rgba(0, 0, 0, 0.16), 0 3px 6px 0 rgba(0, 0, 0, 0.12), 0 5px 12px 4px rgba(0, 0, 0, 0.09)'
    }, {
      name: '二级阴影',
      key: 'box-shadow-2',
      value: '0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 9px 28px 8px rgba(0, 0, 0, 0.05)'
    }, {
      name: '三级阴影',
      key: 'box-shadow-3',
      value: '0 6px 16px -8px rgba(0, 0, 0, 0.08), 0 9px 28px 0 rgba(0, 0, 0, 0.05), 0 12px 48px 16px rgba(0, 0, 0, 0.03)'
    }]);
    return function (_ctx, _cache) {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass("".concat(unref(prefixCls)))
      }, [createVNode(unref(Collapse), {
        bordered: false,
        "expand-icon-position": "right"
      }, {
        expandIcon: withCtx(function (_ref) {
          var isActive = _ref.isActive;
          return [createVNode(unref(CaretRightOutlined), {
            rotate: isActive ? 90 : 0
          }, null, 8 /* PROPS */, ["rotate"])];
        }),
        default: withCtx(function () {
          return [createVNode(unref(CollapsePanel), {
            class: normalizeClass("".concat(unref(prefixCls), "-radius"))
          }, {
            header: withCtx(function () {
              return [createElementVNode("div", {
                class: normalizeClass("".concat(unref(prefixCls), "-radius-header"))
              }, [createElementVNode("span", {
                class: normalizeClass("".concat(unref(prefixCls), "-radius-header-title"))
              }, "圆角", 2 /* CLASS */), createElementVNode("div", {
                onClick: _cache[1] || (_cache[1] = withModifiers(function () {}, ["stop"])),
                class: normalizeClass("".concat(unref(prefixCls), "-radius-header-input"))
              }, [createElementVNode("span", {
                class: normalizeClass("".concat(unref(prefixCls), "-radius-header-input-label"))
              }, "基础圆角", 2 /* CLASS */), createVNode(InputNumber, {
                value: unref(radius)['radius-base'],
                "onUpdate:value": _cache[0] || (_cache[0] = function (val) {
                  return onRadiusChange('radius-base', val);
                }),
                size: "small",
                unit: "px"
              }, null, 8 /* PROPS */, ["value"])], 2 /* CLASS */)], 2 /* CLASS */)];
            }),

            default: withCtx(function () {
              return [createElementVNode("div", {
                class: normalizeClass("".concat(unref(prefixCls), "-radius-content"))
              }, [createElementVNode("div", {
                class: normalizeClass("".concat(unref(prefixCls), "-radius-title"))
              }, "圆角", 2 /* CLASS */), (openBlock(), createElementBlock(Fragment, null, renderList(radiusList, function (item) {
                return createElementVNode("div", {
                  class: normalizeClass("".concat(unref(prefixCls), "-radius-item"))
                }, [createElementVNode("div", {
                  class: normalizeClass("".concat(unref(prefixCls), "-radius-item-title"))
                }, [createElementVNode("span", {
                  class: normalizeClass("".concat(unref(prefixCls), "-radius-item-name"))
                }, toDisplayString(item.name), 3 /* TEXT, CLASS */), createElementVNode("span", {
                  class: normalizeClass("".concat(unref(prefixCls), "-radius-item-key"))
                }, toDisplayString(item.key), 3 /* TEXT, CLASS */)], 2 /* CLASS */), createElementVNode("div", {
                  class: normalizeClass("".concat(unref(prefixCls), "-radius-item-input"))
                }, [createVNode(InputNumber, {
                  size: "small",
                  unit: "px",
                  value: unref(radius)[item.key],
                  "onUpdate:value": function onUpdateValue(val) {
                    return onRadiusChange(item.key, val);
                  }
                }, null, 8 /* PROPS */, ["value", "onUpdate:value"]), createElementVNode("div", {
                  class: normalizeClass("".concat(unref(prefixCls), "-radius-item-preview"))
                }, [createElementVNode("div", {
                  class: normalizeClass("".concat(unref(prefixCls), "-radius-item-preview-box")),
                  style: normalizeStyle("border-radius: ".concat(unref(radius)[item.key], " 0 0 0 "))
                }, null, 6 /* CLASS, STYLE */)], 2 /* CLASS */)], 2 /* CLASS */)], 2 /* CLASS */);
              }), 64 /* STABLE_FRAGMENT */))], 2 /* CLASS */)];
            }),

            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["class"]), createVNode(unref(CollapsePanel), {
            header: "阴影"
          }, {
            header: withCtx(function () {
              return [createElementVNode("div", {
                class: normalizeClass("".concat(unref(prefixCls), "-shadow-header"))
              }, [createElementVNode("span", {
                class: normalizeClass("".concat(unref(prefixCls), "-shadow-header-name"))
              }, " 阴影 ", 2 /* CLASS */)], 2 /* CLASS */)];
            }),

            default: withCtx(function () {
              return [createElementVNode("div", {
                class: normalizeClass("".concat(unref(prefixCls), "-shadow-content"))
              }, [createElementVNode("div", {
                class: normalizeClass("".concat(unref(prefixCls), "-shadow-title"))
              }, "阴影", 2 /* CLASS */), (openBlock(true), createElementBlock(Fragment, null, renderList(shadowList, function (item) {
                return openBlock(), createElementBlock("div", {
                  class: normalizeClass("".concat(unref(prefixCls), "-shadow-item"))
                }, [createElementVNode("div", {
                  class: normalizeClass("".concat(unref(prefixCls), "-shadow-item-header"))
                }, [createElementVNode("div", {
                  class: normalizeClass("".concat(unref(prefixCls), "-shadow-item-title"))
                }, [createElementVNode("span", {
                  class: normalizeClass("".concat(unref(prefixCls), "-shadow-item-name"))
                }, toDisplayString(item.name), 3 /* TEXT, CLASS */), createElementVNode("span", {
                  class: normalizeClass("".concat(unref(prefixCls), "-shadow-item-key"))
                }, toDisplayString(item.key), 3 /* TEXT, CLASS */)], 2 /* CLASS */), createElementVNode("div", {
                  class: normalizeClass("".concat(unref(prefixCls), "-shadow-item-preview"))
                }, [createElementVNode("div", {
                  class: normalizeClass("".concat(unref(prefixCls), "-shadow-item-preview-box")),
                  style: normalizeStyle("box-shadow: ".concat(item.value))
                }, null, 6 /* CLASS, STYLE */)], 2 /* CLASS */)], 2 /* CLASS */), createElementVNode("div", {
                  class: normalizeClass("".concat(unref(prefixCls), "-shadow-item-input"))
                }, [createVNode(unref(InputGroup), {
                  compact: ""
                }, {
                  default: withCtx(function () {
                    return [createVNode(unref(Input), {
                      value: item.value,
                      "onUpdate:value": function onUpdateValue($event) {
                        return item.value = $event;
                      },
                      class: normalizeClass("".concat(unref(prefixCls), "-shadow-item-input-component")),
                      style: {
                        "width": "calc(100% - 64px)"
                      }
                    }, null, 8 /* PROPS */, ["value", "onUpdate:value", "class"]), createVNode(unref(Button), null, {
                      default: withCtx(function () {
                        return [createTextVNode("重置")];
                      }),
                      _: 1 /* STABLE */
                    })];
                  }),

                  _: 2 /* DYNAMIC */
                }, 1024 /* DYNAMIC_SLOTS */)], 2 /* CLASS */)], 2 /* CLASS */);
              }), 256 /* UNKEYED_FRAGMENT */))], 2 /* CLASS */)];
            }),

            _: 1 /* STABLE */
          })];
        }),

        _: 1 /* STABLE */
      })], 2 /* CLASS */);
    };
  }
});

var _export_sfc = function _export_sfc(sfc, props) {
  var target = sfc.__vccOpts || sfc;
  var _iterator = _createForOfIteratorHelper(props),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        key = _step$value[0],
        val = _step$value[1];
      target[key] = val;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return target;
};
var StyleEditor = /* @__PURE__ */_export_sfc(_sfc_main, [["__file", "/Users/chenghongxing/VsCodeProjects/stepin/components/theme-provider/StyleEditor.js"]]);
export { StyleEditor as default };